import { createContext, useContext } from "react";
import UserStore from "./views/User/UserStore";
import EthnicsStore from "./views/Ethnics/EthnicsStore";
import CountryStore from "./views/Country/CountryStore";
import MedicationStore from "./views/Medication/MedicationStore";
import RegimenStore from "./views/Regimen/RegimenStore";
import AdministrativeStore from "./views/AdministrativeUnit/AdministrativeUnitStore";
import RegimenPhaseStore from "./views/RegimenPhase/RegimenPhaseStore";
import PatientStore from "./views/Patient/Stores/PatientStore";
import ConceptStore from "./views/Concept/ConceptStore";
import HealthOganizationUnitStore from "./views/HealthOganizationUnit/HealthOganizationUnitStore";
import ReligionStore from "./views/Religion/ReligionStore";
import ProfessionStore from "./views/Profession/ProfessionStore";
import ConceptLabTestStore from "./views/ConceptLabTest/ConceptLabTestStore";
import ConceptDiagnosticStore from "./views/ConceptDiagnostic/ConceptDiagnosticStore";
import ConceptSymptomStore from "./views/ConceptSymptom/ConceptSymptomStore";
import ConceptISFStore from "./views/ConceptISF/ConceptISFStore";
import StaffStore from "./views/Staff/StaffStore";
import EncounterStore from "./views/Patient/Stores/EncounterStore";
import SpecimenStore from "./views/Specimen/SpecimenStore";
import EpisodeOfCareStore from "./views/Patient/Stores/EpisodeOfCareStore";
import ServiceRequestFormStore from "./views/ServiceRequestForm/Stores/ServiceRequestFormStore";
import HealthDepartmentStore from "./views/HealthDepartment/HealthDepartmentStore";
import StockKeepingUnitStore from "./views/StockKeepingUnit/StockKeepingUnitStore";
import SpecimenTypeStore from "./views/SpecimenType/SpecimenTypeStore";
import SummaryStore from "./views/Patient/Stores/SummaryStore";
import SourceStore from "./views/Source/SourceStore";
import RegionStore from "./views/Region/RegionStore";
import MedicationNameStore from "./views/MedicationName/MedicationNameStore";
import HealthOganizationUnitDetailStore from "./views/HealthOganizationUnit/Details/HealthOganizationUnitDetailStore";
import PulmonaryTBTypeStore from "./views/PulmonaryTBType/PulmonaryTBTypeStore";
import PatientHistoryStore from "./views/PatientHistory/PatientHistoryStore";
import ContactPersonStore from "./views/ContactPerson/ContactPersonStore";
import MedicationSideEffectsStore from "./views/MedicationSideEffects/MedicationSideEffectsStore";
import SystemConfigStore from "./views/SystemConfig/SystemConfigStore";
import StoreStore from "./views/Store/StoreStore";
import RegimenTestConceptStore from "./views/RegimenTestConcept/RegimenTestConceptStore";
import DictionarySystemStore from './views/DictionarySystem/DictionarySystemStore';
import RoleStore from "./views/Role/RoleStore";
import EtbTreatmentBookStores from "./views/Patient/Stores/EtbTreatmentBookStores";
import RelatedPersonStore from "./views/RelatedPerson/RelatedPersonStore";
import EtbRelatedPersonStore from "./views/Patient/Stores/EtbRelatedPersonStore";
import DuplicatePatientStore from "./views/DuplicatePatient/DuplicatePatientStore";
import Report01Store from "./views/Report/ETB/ImportReport/Report01/Report01Store";
import Report02Store from "./views/Report/ETB/ImportReport/Report02/Report02Store";
import Report03Store from "./views/Report/ETB/ImportReport/Report03/Report03Store";
import Report04Store from "./views/Report/ETB/ImportReport/Report04/Report04Store";
import Report05Store from "./views/Report/ETB/ImportReport/Report05/Report05Store";
import PatientInCompleteADSMStore from "./views/PatientInCompleteADSM/PatientInCompleteADSMStore";
import PatientLateAppointmentStore from "./views/PatientLateAppointment/PatientLateAppointmentStore";
import PatientDoNotTestRForLpaStore from "./views/PatientDoNotTestRForLpa/PatientDoNotTestRForLpaStore";
import PatientWithoutRegimenEAndIndividualStore from "./views/PatientWithoutRegimenEAndIndividual/PatientWithoutRegimenEAndIndividualStore";
import ViewReport05Store from "./views/Report/ETB/ViewReport/Report05/Report05Store";
import ViewReport02Store from "./views/Report/ETB/ViewReport/Report02/Report02Store";
import ViewReport04Store from "./views/Report/ETB/ViewReport/Report04/Report04Store";
import PatientADSMStore from "./views/PatientADSM/PatientADSMStore";
import LabTestWaitingResultStore from "./views/LabTestWaitingResult/LabTestWaitingResultStore";
import LabTestHasResultStore from "./views/LabTestHasResult/LabTestHasResultStore";
import ViewReport01Store from "./views/Report/ETB/ViewReport/Report01/Report01Store";
import PatientAppointmentTodayStore from "./views/PatientAppointmentToday/PatientAppointmentTodayStore";
import PatientMedicationHistoryStore from "./views/PatientMedicationHistory/PatientMedicationHistoryStore";
import PatientPositiveTestWithoutAntibiogramStore from "./views/PatientPositiveTestWithoutAntibiogram/PatientPositiveTestWithoutAntibiogramStore";
import PatientTransferStore from "./views/PatientTransfer/PatientTransferStore";
import M5Store from "./views/ExportData/ETB/M5/M5Store";
import PatientReminderCardStore from "./views/PatientReminderCard/PatientReminderCardStore";
// import No08Store from "./views/Report/ETB/Canvas/No08Store";
import PatientFromNotificationStore from "./views/PatientFromNotification/PatientFromNotificationStore";
import MedicationRecordSheetStore from "./views/MedicationRecordSheet/MedicationRecordSheetStore";
import ActivityLogStore from "./views/ActivityLog/ActivityLogStore";
import ViewReport08Store from "./views/Report/ETB/ViewReport/Report08/Report08Store";
import ViewReport03Store from "./views/Report/ETB/ViewReport/Report03/Report03Store";
import RoleDetailStore from "./views/RoleDetail/RoleDetailStore";
import DashboardStore from "./views/dashboard/DashboardStore";
import AdministrativeUnitRefInfoStore from "./views/AdministrativeUnitRefInfo/AdministrativeUnitRefInfoStore";
import AllTbPatientStore from "./views/AllTbPatient/AllTbPatientStore";
import LocalReport01Store from "./views/Report/ETB/ViewReport/LocalReport01/LocalReport01Store";
import LocalReport02Store from "./views/Report/ETB/ViewReport/LocalReport02/LocalReport02Store";
import LocalReport05Store from "./views/Report/ETB/ViewReport/LocalReport05/LocalReport05Store";
import LocalReport04Store from "./views/Report/ETB/ViewReport/LocalReport04/LocalReport04Store";
import LocalReport03Store from "./views/Report/ETB/ViewReport/LocalReport03/LocalReport03Store";
import ViewReport07Store from "./views/Report/ETB/ViewReport/Report07/Report07Store";
import AdverseEventReportStore from "./views/Report/ETB/ViewReport/AdverseEventReport/AdverseEventReportStore";
import LocalReportAssessmentOfADSMStore from "./views/Report/ETB/ViewReport/LocalReportAssessmentOfADSM/LocalReportAssessmentOfADSMStore";
import PatientFromOtherStore from "./views/PatientFromOther/PatientFromOtherStore";

export const store = {
  userStore: new UserStore(),
  ethnicsStore: new EthnicsStore(),
  countryStore: new CountryStore(),
  medicationStore: new MedicationStore(),
  regimenStore: new RegimenStore(),
  administrativeStore: new AdministrativeStore(),
  regimenPhaseStore: new RegimenPhaseStore(),
  patientStore: new PatientStore(),
  conceptStore: new ConceptStore(),
  healthOganizationUnitStore: new HealthOganizationUnitStore(),
  religionStore: new ReligionStore(),
  professionStore: new ProfessionStore(),
  conceptLabTestStore: new ConceptLabTestStore(),
  conceptDiagnosticStore: new ConceptDiagnosticStore(),
  conceptSymptomStore: new ConceptSymptomStore(),
  conceptISFStore: new ConceptISFStore(),
  staffStore: new StaffStore(),
  encounterStore: new EncounterStore(),
  specimenStore: new SpecimenStore(),
  episodeOfCareStore: new EpisodeOfCareStore(),
  healthDepartmentStore: new HealthDepartmentStore(),
  ServiceRequestFormStore: new ServiceRequestFormStore(),
  stockKeepingUnitStore: new StockKeepingUnitStore(),
  specimenTypeStore: new SpecimenTypeStore(),
  summaryStore: new SummaryStore(),
  sourceStore: new SourceStore(),
  regionStore: new RegionStore(),
  medicationNameStore: new MedicationNameStore(),
  healthOganizationUnitDetailStore: new HealthOganizationUnitDetailStore(),
  pulmonaryTBTypeStore: new PulmonaryTBTypeStore(),
  patientHistoryStore: new PatientHistoryStore(),
  contactPersonStore: new ContactPersonStore(),
  medicationSideEffectsStore: new MedicationSideEffectsStore(),
  systemConfigStore: new SystemConfigStore(),
  storeStore: new StoreStore(),
  regimenTestConceptStore: new RegimenTestConceptStore(),
  dictionarySystemStore: new DictionarySystemStore(),
  roleStore: new RoleStore(),
  etbTreatmentBookStores: new EtbTreatmentBookStores(),
  relatedPersonStore: new RelatedPersonStore(),
  etbRelatedPersonStore: new EtbRelatedPersonStore(),
  duplicatePatientStore: new DuplicatePatientStore(),
  report01Store: new Report01Store(),
  report02Store: new Report02Store(),
  report03Store: new Report03Store(),
  report04Store: new Report04Store(),
  report05Store: new Report05Store(),
  patientInCompleteADSMStore: new PatientInCompleteADSMStore(),
  patientLateAppointmentStore: new PatientLateAppointmentStore(),
  patientDoNotTestRForLpaStore: new PatientDoNotTestRForLpaStore(),
  patientWithoutRegimenEAndIndividualStore: new PatientWithoutRegimenEAndIndividualStore(),
  viewReport05Store: new ViewReport05Store(),
  viewReport02Store: new ViewReport02Store(),
  viewReport04Store: new ViewReport04Store(),
  adsmPatient: new PatientADSMStore(),
  labTestWaitingResultStore: new LabTestWaitingResultStore(),
  labTestHasResultStore: new LabTestHasResultStore(),
  viewReport01Store: new ViewReport01Store(),
  patientAppointmentTodayStore: new PatientAppointmentTodayStore(),
  patientMedicationHistoryStore: new PatientMedicationHistoryStore(),
  patientPositiveTestWithoutAntibiogramStore: new PatientPositiveTestWithoutAntibiogramStore(),
  patientTransferStore: new PatientTransferStore(),
  m5Store: new M5Store(),
  patientReminderCardStore: new PatientReminderCardStore(),
  administrativeUnitRefInfoStore: new AdministrativeUnitRefInfoStore(),
  // no08Store: new No08Store(),
  patientFromNotificationStore: new PatientFromNotificationStore(),
  medicationRecordSheetStore: new MedicationRecordSheetStore(),
  activityLogStore: new ActivityLogStore(),
  viewReport08Store: new ViewReport08Store(),
  viewReport03Store: new ViewReport03Store(),
  roleDetailStore: new RoleDetailStore(),
  dashboardStore : new DashboardStore(),
  allTbPatientStore: new AllTbPatientStore(),
  viewLocalReport01Store: new LocalReport01Store(),
  viewLocalReport02Store: new LocalReport02Store(),
  viewLocalReport05Store: new LocalReport05Store(),
  viewLocalReport04Store: new LocalReport04Store(),
  viewLocalReport03Store: new LocalReport03Store(),
  viewReport07Store: new ViewReport07Store(),
  viewAdverseEventReportStore: new AdverseEventReportStore(),
  viewLocalReportAssessmentOfADSMStore: new LocalReportAssessmentOfADSMStore(),
  patientFromOtherStore: new PatientFromOtherStore(),
};

export const StoreContext = createContext(store);

export function useStore() {
  return useContext(StoreContext);
}
